<div class="flex items-center h-[53.426vh] w-full lg:w-[84.375vw]" [ngClass]="{'!h-full': showRiepilogo}">
  <div class="relative h-[53.426vh] w-full lg:w-[84.375vw]" *ngIf="!showRiepilogo">
    
      <div class="card-question w-full h-[53.426vh] lg:w-[84.375vw]" *ngFor="let item of questionario,let index = index" [ngClass]="{
          'zero-matrix z-[5]': index === currentQuestionIndex -1,
          'absolute top-0 first-matrix z-[4]': index === currentQuestionIndex,
          'second-matrix z-[3]': index === currentQuestionIndex + 1,
          'third-matrix z-[2]': index === currentQuestionIndex + 2,
          'fourth-matrix z-[1]': index === currentQuestionIndex + 3,
          'hidden': index > currentQuestionIndex + 3}">
        <div class="p-[5vh] flex flex-col justify-start " *ngIf="!showRiepilogo"
          (click)="setSurveyId(item._id)">
          <div>
            <h1
              class="text-[var(--secondary)] text-[2.778vh] font-avantgarde font-bold">
              Domanda {{index +1}}</h1>

          </div>
          <div class="mt-[1.5vh]">
            <p
              class="text-[var(--secondary)] text-[2.4vh] font-avantgarde font-normal">
              {{item.question}}</p>
          </div>

          <div class="size-full mt-[1.5vh]">
            <div class="size-full  flex items-center z-20 mt-[3vh]">
              <div *ngIf="item.questionType !== 'open'">
                <div class="flex items-center justify-start mt-[1.5vh]" *ngFor="let answer of item.questionTypeValues">
                  <div class="">
                    <div
                      class="rounded-[1.5vh] overflow-hidden h-[4vh] w-[4vh] bg-white border-[1px] flex items-center justify-center">
                      <div
                        class="h-[4vh] w-[4vh] rounded-[1vh] flex justify-center items-center check"
                        [ngClass]="{'bg-[var(--primary)]': selectedAnswer === answer}"
                        (click)="onCheckboxChange(answer)">
                        <img class="h-[3vh] w-[3vh]" *ngIf="selectedAnswer === answer" src="../../../assets/checkIcon.svg">
                      </div>
                    </div>
                  </div>
                  <div class="size-full ml-[1vw]">
                    <p
                      class="font-heebo font-normal text-[2.4vh] text-[var(--secondary)]">
                      {{answer}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="size-full" *ngIf="item.questionType === 'open'">
                <textarea class="!bg-transparent" placeholder="inserisci testo" [(ngModel)]="text "
                  class="text-area h-full"></textarea>
              </div>
            </div>
          </div>


        </div>

      </div>

  </div>
  <div *ngIf="showRiepilogo&&!showRingraziamenti" class="flex flex-col size-full justify-center items-center">
    <div class="mb-[2vh] flex items-center justify-start size-full overflow-auto">
      <div
        class="font-avantgarde font-bold text-[3vh] text-[var(--quaternary)]">
        Riepilogo risposte</div>
    </div>
    <div
      class="p-[3vh] flex flex-col justify-start size-full bg-[var(--tertiary)] rounded-[2.5vh] ombra-pad h-full">
      <div *ngFor="let item of questionario ; let index =index">
        <div class="size-full flex justify-start items-center mt-[1vh]">
          <h1
            class="text-[var(--secondary)] text-[3vh] font-avantgarde font-bold">
            Domanda {{index+1}}</h1>
        </div>
        <div class="mt-[1vh]">
          <p
            class="text-[var(--secondary)] text-[2.5vh] font-avantgarde font-normal">
            {{item.question}}</p>
        </div>
        <div class="my-[1vh]">

          <div class="mt-[1vh]">
            <p class="font-normal  font-avantgarde text-[2vh]">
              {{item.answerValue}}</p>

          </div>
        </div>
        <hr class="w-full bord">
      </div>
    </div>

    <div class=" mt-[10vh]">
      <app-button buttonCustomClass="w-[80vw] lg:w-[30vw]" [text]="'Concludi questionario'" (click)="sendAnswers()" [backgroundColor]="'var(--quaternary)'"
        [color]="'var(--tertiary)'" [borderRadius]="'26'"></app-button>
    </div>

  </div>
</div>
<div *ngIf="showRingraziamenti"
  class="p-[2.5vh] mt-[2vh] lg:p-[60px] mb-[5vh]  flex flex-col justify-start size-full bg-[var(--tertiary)] rounded-[2.5vh] ombra-pad">

  <div class="mx-auto w-20 h-20 bg-[var(--primary)] rounded-full mb-5 flex place-content-center">
    <img class="" src="../../../assets/checkIcon.svg">
  </div>
  <div class="text-[16px] font-bold mb-10 text-center">Hai concluso correttamente
    il questionario</div>
  <div class="font-normal text-[14px] text-center">
    Grazie per aver compilato il questionario
    di DaPico HR, i dati da te forniti serviranno
    per progettare al meglio i nostri prodotti.</div>
</div>
<div class="mt-[10vh] " *ngIf="!showRiepilogo">
  <div class="flex items-center place-content-center lg:justify-end gap-[2.777vh]">
    <div class=" z-[99999999]">
      <app-button [text]="'Precedente'" (click)="previousQuestion()" [backgroundColor]="'var(--quaternary)'"
        [color]="'var(--tertiary)'" [borderRadius]="'26'"></app-button>
    </div>
    <div class="" [class.opacity-50]="selectedAnswer.length===0 && text ===''"
      [style.pointer-events]="selectedAnswer.length===0 && text ==='' ? 'none' : 'auto'">
      <app-button [text]="'Prossima'" (click)="nextQuestion()" [backgroundColor]="'var(--quaternary)'"
        [color]="'var(--tertiary)'" [borderRadius]="'26'"></app-button>
    </div>
  </div>
</div>